module.exports = __webpack_public_path__ + "img/icon-wifi.d72ad1e9.svg";